import { Dealer, License, Customer } from '@app/models';

export class LicenseBundle {
  licenseBundleId: string;
  dealerId: string;
  dealer: Dealer;
  orderNumber: string;
  creationUserId: string;
  creationTime: Date;
  licenseKey: string;
  offlineActivation: number;
  offlineLicenseKey: string;
  activationEnabledFrom: Date;
  activationDisabled: number;
  deleted: number;
  customerId: string;
  customer: Customer;
  activationTime: Date;
  customerStudyId: string;
  licenses?: License[];
  offlineLicenseKeyExpirationTime: Date;

  constructor(params: LicenseBundleParams) {
    this.licenseBundleId = params.licenseBundleId;
    this.dealerId = params.dealerId;
    this.orderNumber = params.orderNumber;
    this.creationUserId = params.creationUserId;
    this.creationTime = params.creationTime;
    this.licenseKey = params.licenseKey;
    this.offlineActivation = params.offlineActivation;
    this.offlineLicenseKey = params.offlineLicenseKey;
    this.activationEnabledFrom = params.activationEnabledFrom;
    this.activationDisabled = params.activationDisabled;
    this.deleted = params.deleted;
    this.customerId = params.customerId;
    this.activationTime = params.activationTime && new Date(params.activationTime);
    this.customerStudyId = params.customerStudyId;
    this.offlineLicenseKeyExpirationTime = params.offlineLicenseKeyExpirationTime && new Date(params.offlineLicenseKeyExpirationTime);

    this.customer = params.customer;
    this.dealer = params.dealer && new Dealer(params.dealer);
  }
}

export interface LicenseBundleParams {
  licenseBundleId: string;
  dealerId: string;
  dealer: Dealer;
  orderNumber: string;
  creationUserId: string;
  creationTime: Date;
  licenseKey: string;
  offlineActivation: number;
  offlineLicenseKey: string;
  activationEnabledFrom: Date;
  activationDisabled: number;
  deleted: number;
  customerId: string;
  customer: Customer;
  activationTime: Date;
  customerStudyId: string;
  offlineLicenseKeyExpirationTime: Date;
  licenses?: License[];
}
